import { 
    ATUALIZA_AGENTES, 
    VERIFICAR_AGENTE_CONECTADO, 
    EXTENSION_AVAILABLE, 
 } from '../actions/types';

const INITIAL_STATE = {
    agents: {},
    agente: {
        conectado : false,
        c_agente_id: '',
        name: '',
        status: {exp:0, iat: 0, name: ''},
        extension: {},
        queues: {}
    },
    extensionAvailable:{}
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ATUALIZA_AGENTES:
            return { ...state, agents: action.payload }
        case VERIFICAR_AGENTE_CONECTADO:
            return { ...state, agente: action.payload};
        case EXTENSION_AVAILABLE:
            return { ...state, extensionAvailable: action.payload};
        default:
            return state;   
    }
}